module.exports = __webpack_public_path__ + "img/temp.5b099187.png";